import { render } from "./BaseInformation.vue?vue&type=template&id=7134069f&scoped=true"
import script from "./BaseInformation.vue?vue&type=script&lang=ts"
export * from "./BaseInformation.vue?vue&type=script&lang=ts"

import "./BaseInformation.vue?vue&type=style&index=0&id=7134069f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7134069f"

export default script